const setCookie = (cname, cvalue) => {
  const d = new Date();
  d.setTime(d.getTime() + 365 * 24 * 60 * 60 * 1000);

  document.cookie = `${cname}=${cvalue};expires=${d.toUTCString()};`;
};

const getCookie = cname => {
  const d = new Date();
  d.setTime(d.getTime() + 365 * 24 * 60 * 60 * 1000);
  const c = new RegExp(`${cname}=([^;]+)`);

  return (c.exec(document.cookie) || [])[1];
};

export { setCookie, getCookie };
